import { useEffect } from 'react';
import { useSkillsStore } from '../store';

export function useSkills() {
  const skills = useSkillsStore((s) => s.skills);
  const loading = useSkillsStore((s) => s.loading);
  const error = useSkillsStore((s) => s.error);
  const fetch = useSkillsStore((s) => s.actions.fetch);

  useEffect(() => {
    if (skills.length === 0 && !loading) {
      void fetch();
    }
  }, []); // biome-ignore lint: mount-only effect

  return { skills, loading, error, refetch: fetch };
}
